<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>
        <h1 class="titulo mb-3">CONFIGURAÇÃO DE USUÁRIOS ADMINISTRATIVOS</h1>
        <v-card>
            <v-card-text>
                <div id="tabs" class="container">
                    <div class="tabs">
                        <a @click="activetab=LISTAGEM" :class="{ active: activetab === LISTAGEM }">Usuários</a>
                        <a @click="activetab=ALTERAR_PERFIL" :class="{ active: activetab === ALTERAR_PERFIL }">Gerenciamento de Perfis</a>
                        <a @click="activetab=GERENCIAMENTO_PERMISSOES" :class="{ active: activetab === GERENCIAMENTO_PERMISSOES }">Gerenciamento de Permissões</a>
                        <a @click="activetab=HIERARQUIA_ASSISTENTE" :class="{ active: activetab === HIERARQUIA_ASSISTENTE }">Config. Hierarquia Assistente</a>
                        <a @click="activetab=USUARIOS_BLOQUEADOS" :class="{ active: activetab === USUARIOS_BLOQUEADOS }">Bloq. Usuários</a>
                    </div>
                    <div v-if="activetab === LISTAGEM" class="tabcontent">
                        <v-layout class="d-flex justify-space-between flex-wrap">
                            <v-btn class="transition" color="primary" rounded @click="filter_open = !filter_open">
                                <v-icon small style="margin-right: 10px;">rod-filter</v-icon>
                                Filtrar por:
                                <v-icon :class="{ 'rotate90': filter_open }" small>chevron_right</v-icon>
                            </v-btn>
                            <v-btn color="primary" @click="downloadReport">
                                <v-icon left size="18">
                                    mdi-file-chart
                                </v-icon>
                                SALVAR RELATÓRIO
                            </v-btn>
                        </v-layout>
                        <collapse-transition>
                            <m-form ref="filter"
                                    class="mt-8"
                                    v-show="filter_open">
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <Autocomplete
                                                :items="usuarios"
                                                v-model="filters.usuario"
                                                item-text="showText"
                                                label="Usuário"
                                                ref="user"
                                                outlined
                                                item-value="login_usuario"
                                                placeholder="Selecione o usuário"
                                                hide-details
                                        />
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-select label="Vendas Backoffice:"
                                                  placeholder="Selecione"
                                                  outlined
                                                  :items="opcoes_backoffice"
                                                  item-text="label"
                                                  item-value="value"
                                                  v-model="filters.vendas_backoffice"
                                        />
                                    </v-col>
                                    <v-col cols="10" sm="6" md="6">
                                        <Autocomplete label="Perfil Administrativo:"
                                                      v-model="filters.perfil_administrativo"
                                                      multiple
                                                      :items="tipos_usuarios"
                                                      :hide-selected="false"
                                                      item-value="value"
                                                      item-text="label"
                                                      placeholder="Selecione os tipos de usuários"
                                        />
                                    </v-col>
                                    <v-col cols="10" sm="6" md="6">
                                        <Autocomplete label="Permissão Administrativa:"
                                                      v-model="filters.perfissoes_administrativas"
                                                      multiple
                                                      :items="niveis_permissoes_perfil_filter_data"
                                                      :hide-selected="false"
                                                      item-value="value"
                                                      item-text="label"
                                                      placeholder="Selecione os tipos de usuários"
                                        />
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                                v-model="filters.cpf"
                                                label="CPF/CNPJ"
                                                outlined
                                                placeholder="Insira o CPF/CNPJ"
                                                hide-details
                                                v-mask="['###.###.###-##','##.###.###/####-##']"
                                                :maxlength="20"
                                        />
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <Autocomplete
                                                label="Perfil Comercial:"
                                                v-model="filters.perfil_comercial"
                                                multiple
                                                :hide-selected="false"
                                                item-value="value"
                                                item-text="label"
                                                placeholder="Selecione os tipos de usuários"
                                                hide-details
                                                :items="perfil_comercial"
                                                class="mb-5"
                                        />
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-select
                                                label="Status do Usuário:"
                                                placeholder="Selecione o status do usuário"
                                                outlined
                                                clearable
                                                :items="OpcoesStatusUsuario"
                                                item-text="label"
                                                item-value="value"
                                                v-model="filters.bloqueado_painel"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row class="justify-end">
                                    <v-col cols="6" sm="3">
                                        <v-btn class="mr-10 mb-5" color="secondary" block @click="limparFiltro">
                                            Limpar
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="6" sm="3">
                                        <v-btn color="primary" block @click="filtrar">
                                            Filtrar
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </m-form>
                        </collapse-transition>
                        <!-- Tabela -->

                        <DataTable :headers="headers"
                                   :params="params"
                                   :filter="dtFiltro"
                                   url="/painel/backoffice/users"
                                   overflow-y-visible
                        >
                            <template v-slot:header="header">
                                <th v-for="(header, i) in headers" :key="i" style="height: 5px">
                                    <div v-if="header.value === 'perfil_adm'" class="tooltip-icon position-relative" style="width: 18px; height: 18px; position: relative; margin-top: -35px; margin-left: 95%">
                                        <v-tooltip bottom color="#222">
                                            <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on">
                                                    <div class="d-flex">
                                                        <v-icon size="18" color="primary">mdi-help-box</v-icon>
                                                    </div>
                                                </span>
                                            </template>
                                            <p class="mb-0" style="color:whitesmoke;max-width: 250px;">Nível de acesso ao painel administrativo considerando a configuração da aba de privilégios administrativos.</p>
                                        </v-tooltip>
                                    </div>
                                    <div v-if="header.value === 'vendas_backoffice'" class="tooltip-icon position-relative" style="width: 18px; height: 18px; position: relative; margin-top: -35px; margin-left: 100%">
                                        <v-tooltip bottom color="#222">
                                            <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on">
                                                    <div class="d-flex">
                                                        <v-icon size="18" color="primary">mdi-help-box</v-icon>
                                                    </div>
                                                </span>
                                            </template>
                                            <p class="mb-0" style="color:whitesmoke;max-width: 250px;">Permite acesso exclusivo a Plataforma de Vendas a partir da tela de login. Ao logar, permite que o usuário selecione qualquer comissionado ativo para realizar a venda.</p>
                                        </v-tooltip>
                                    </div>
                                    <div v-if="header.value === 'permissao_perfil_adm'" class="tooltip-icon position-relative" style="width: 18px; height: 18px; position: relative; margin-top: -35px; margin-left: 95%">
                                        <v-tooltip bottom color="#222">
                                            <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on">
                                                    <div class="d-flex">
                                                        <v-icon size="18" color="primary">mdi-help-box</v-icon>
                                                    </div>
                                                </span>
                                            </template>
                                            <p class="mb-0" style="color:whitesmoke;max-width: 250px;">Divisão do mesmo nível de acesso do perfil para classificar a permissão de ações e visualizações do usuário.</p>
                                        </v-tooltip>
                                    </div>
                                </th>
                            </template>
                            <template v-slot:items="{item}">
                                <td>{{ item.login }} - {{ item.nome }}</td>
                                <td>{{ item.cpf }}</td>
                                <td style="min-width: 12rem;">{{ item.perfil_comercial }}</td>
                                <td>
                                    <v-select
                                            class="center margin-10px"
                                            placeholder="Selecione"
                                            outlined
                                            :value="item.perfil_adm"
                                            :items="tipos_usuarios"
                                            item-text="label"
                                            item-value="value"
                                            @change="actionPerfilAdmin(item.login, $event)"
                                    />
                                </td>
                                <td v-if="isPerfilAdmRelacionado(item.perfil_adm)">
                                    <v-select
                                            class="center margin-10px"
                                            placeholder="Selecione"
                                            outlined
                                            :value="item.permissao_perfil_adm"
                                            :items="permissoesRelacionadasAoPerfil(item.perfil_adm)"
                                            item-text="label"
                                            item-value="value"
                                            @change="actionNivelPermissaoAdmin(item.login, $event)"
                                    />
                                </td>
                                <td v-else>
                                    <v-select
                                            class="center margin-10px"
                                            placeholder="Não se aplica"
                                            outlined
                                            :value="item.perfil_adm"
                                            :items="selectNaoSeAplica"
                                            item-text="label"
                                            item-value="value"
                                            disabled
                                            filled
                                    />
                                </td>
                                <td class="text-center">
                                    {{ item.bloqueado_painel === null || item.bloqueado_painel === undefined ? StatusUsuario.Liberado.label : (item.bloqueado_painel === StatusUsuario.Bloqueado.value ? StatusUsuario.Bloqueado.label : StatusUsuario.Liberado.label) }}
                                </td>
                                <td>
                                    <v-switch
                                            class="center"
                                            v-model="item.vendas_backoffice"
                                            :value="item.vendas_backoffice"
                                            @change="actionBackOffice(item.login, item.vendas_backoffice, $event)"
                                    ></v-switch>
                                </td>
                            </template>
                        </DataTable>
                    </div>
                    <div v-if="activetab === ALTERAR_PERFIL" class="tabcontent">
                        <PerfilAdmin />
                    </div>
                    <div v-if="activetab === GERENCIAMENTO_PERMISSOES" class="tabcontent">
                        <GerenciamentoPermissoes />
                    </div>
                    <div v-if="activetab === HIERARQUIA_ASSISTENTE" class="tabcontent">
                        <Assistant />
                    </div>
                    <div v-if="activetab === USUARIOS_BLOQUEADOS" class="tabcontent">
                        <UsuariosBloqueados />
                    </div>
                </div>
            </v-card-text>
        </v-card>
        <br>
    </v-container>
</template>

<script>
  import { alert, notification } from '../../plugins/helpers'
  import { PerfisAdmin, OpcoesStatusUsuario, StatusUsuario } from '@/plugins/constants'
  import Autocomplete from '../../components/Autocomplete.vue'
  import PerfilAdmin from './PerfilAdmin.vue'
  import Assistant from './Assistant.vue'
  import { AlertTypes } from '../../plugins/alerts_types'
  import UsuariosBloqueados from './UsuariosBloqueados.vue'
  import GerenciamentoPermissoes from './GerenciamentoPermissoes.vue'
  import * as Qs from 'qs'

  export default {
    name: 'UsuarioConfig',
    components: {
      Autocomplete,
      PerfilAdmin,
      Assistant,
      GerenciamentoPermissoes,
      UsuariosBloqueados
    },
    data: () => ({
      selectNaoSeAplica: [{ value: 0, text: 'Não se aplica' }],
      activetab: 'listagem',
      dtFiltro: {},
      PerfisAdmin,
      headers: [
        { text: 'Usuário', value: 'login', icon: 'mdi-help-box' },
        { text: 'CPF/CNPJ', value: 'cpf' },
        { text: 'Perfil Comercial', value: 'perfil_comercial' },
        { text: 'Perfil administrativo', value: 'perfil_adm', icon: 'mdi-help-box', iconIsNedded: true, infoList: ['Nível de acesso ao painel administrativo considerando a configuração da aba de privilégios administrativos.'], opacity: 0 },
        { text: 'Permissão do perfil', value: 'permissao_perfil_adm', icon: 'mdi-help-box', iconIsNedded: true, infoList: ['Divisão do mesmo nível de acesso do perfil para classificar a permissão de ações e visualizações do usuário.'], opacity: 0 },
        { text: 'Status do Usuário', value: 'bloqueado_painel', align: 'center' },
        { text: 'Vendas backoffice', value: 'vendas_backoffice', icon: 'mdi-help-box', iconIsNedded: true, infoList: ['Permite acesso exclusivo a Plataforma de Vendas a partir da tela de login. Ao logar, permite que o usuário selecione qualquer comissionado ativo para realizar a venda.'], opacity: 0 }
      ],
      listaUsuarios: [],
      editar: false,
      filter_open: false,
      perfil_comercial: [],
      StatusUsuario,
      OpcoesStatusUsuario,
      filters: {
        usuario: '',
        cpf: '',
        perfil_comercial: '',
        vendas_backoffice: '',
        perfil_administrativo: [],
        permissoes_com_perfil_relacionado: [],
        perfissoes_administrativas: [],
        bloqueado_painel: null
      },
      tipos_usuarios: [],
      niveis_permissoes_perfil: [],
      usuarios: [],
      opcoes_backoffice: [
        {
          label: 'Sim',
          value: 1
        },
        {
          label: 'Não',
          value: 0
        },
        {
          label: 'Todos',
          value: 2
        }
      ],
      params: {
        pagination: {
          rowsPerPage: 12,
          page: 1,
          sortBy: 'login',
          descending: false
        },
        data_hora_de: null,
        data_hora_ate: null,
        funcionalidade: null,
        operacao: null
      },
      opacity_perfil: 0,
      opacity_permissao_perfil: 0,
      opacity_backoffice: 0
    }),
    computed: {
      LISTAGEM: () => 'listagem',
      ALTERAR_PERFIL: () => 'alterar_perfis',
      GERENCIAMENTO_PERMISSOES: () => 'gerenciamento_permissoes',
      HIERARQUIA_ASSISTENTE: () => 'hierarquia_assistente',
      USUARIOS_BLOQUEADOS: () => 'usuarios_bloqueados',
      niveis_permissoes_perfil_filter_data () {
        return [...this.niveis_permissoes_perfil, { 'label': 'Não Definido', value: null }]
      }
    },
    watch: {
      activetab: {
        immediate: true,
        async handler (newVal) {
          if (newVal === this.LISTAGEM) {
            try {
              await Promise.all([
                this.loadUsuarios(),
                this.loadPermissoesAdministrativas(),
                this.loadPerfisAdministrativos(),
                this.loadPerfisComerciais(),
                this.loadPermissoesComPerfilRelacionado()
              ])
            } catch (error) {
              notification('error', error.message)
            }
          }
        }
      }
    },
    methods: {
      async loadPerfisComerciais () {
        try {
          let perfisComerciais = await this.$http.get('/painel/backoffice/perfis-comerciais')
          this.perfil_comercial = perfisComerciais.data
        } catch (error) {
          throw new Error('Erro ao carregar os perfis comerciais')
        }
      },
      permissoesRelacionadasAoPerfil (perfilAdmId) {
        return this.permissoes_com_perfil_relacionado
          .filter(p => p.id_perfil_relacionado === perfilAdmId)
          .map(p => ({
            label: p.perfil_permissao.nome,
            value: p.perfil_permissao.id_perfil
          }))
      },
      async loadPermissoesComPerfilRelacionado () {
        try {
          const response = await this.$http.get('/painel/backoffice/permissions-related-profile')

          this.permissoes_com_perfil_relacionado = response.data || []
        } catch (error) {
          notification(AlertTypes.ERROR, 'Erro ao carregar permissões com perfis relacionados: ' + (error.response?.data?.error || error.message))
          this.permissoes_com_perfil_relacionado = []
        }
      },
      async loadPerfisAdministrativos () {
        await this.$http.get('/painel/backoffice/perfis-administrativos')
          .then(response => {
            let perfisAdministrativos = response.data.map((item) => {
              return {
                label: item.nome,
                value: item.id_perfil
              }
            })
            this.tipos_usuarios = perfisAdministrativos
          })
          .catch(() => {
            throw new Error('Erro ao carregar os perfis administrativos')
          })
      },
      async loadPermissoesAdministrativas () {
        await this.$http.get('/painel/backoffice/permissoes-administrativas')
          .then(response => {
            let permissoesAdministrativas = response.data.map((item) => {
              return {
                label: item.nome,
                value: item.id_perfil
              }
            })
            this.niveis_permissoes_perfil = permissoesAdministrativas
          })
          .catch(() => {
            throw new Error('Erro ao carregar os perfis administrativos')
          })
      },
      async loadUsuarios () {
        await this.$http
          .get('/painel/configuracao/usuarios')
          .then((result) => {
            if (result.data) {
              this.usuarios = result.data.usuarios
              this.tratarUsuarios()
              // WARN: Não tire essa linha, ela é necessária para que o datatable seja renderizado
              this.filtrar()
            }
          })
          .catch(() => {
            throw new Error('Não foi possível buscar os usuários!')
          })
      },
      isPerfilAdmRelacionado (perfilAdm) {
        return (this.permissoes_com_perfil_relacionado.some(rel => rel.id_perfil_relacionado === perfilAdm) &&
          perfilAdm !== this.PerfisAdmin.Sem_Acesso.id_banco
        )
      },
      downloadReport () {
        const filtros = { ...this.filters }
        const headersExport = this.headers
          .filter(h => h.value)
          .map(h => h.value)

        const headersFormatadoExport = this.headers
          .filter(h => h.value)
          .map(h => h.text)

        const encoded_params = Qs.stringify({
          filter: filtros,
          pagination: { sortBy: 'login', descending: true },
          headers: headersExport,
          headers_formatado: headersFormatadoExport
        }, {
          arrayFormat: 'brackets',
          encode: true
        })

        try {
          window.open(`${this.ws}/backoffice/users/exportar?${encoded_params}`)
        } catch (error) {
          notification('error', `${error.response?.data?.error || error.message}`)
        }
      },
      tratarUsuarios () {
        let espaco
        const usuariosFiltrados = this.usuarios.filter((usuario) => {
          return usuario.login
        })

        let usuarios = usuariosFiltrados.map((usuario) => {
          espaco = ' - '
          if (!usuario.nome) {
            usuario.nome = ''
          }
          return {
            login_usuario: usuario.login,
            nome: usuario.nome,
            showText: (usuario.login + espaco + usuario.nome)
          }
        })
        this.usuarios = usuarios.sort(this.ordenar)
      },
      limparFiltro () {
        this.filters = {
          usuario: '',
          cpf: '',
          perfil_comercial: [],
          vendas_backoffice: '',
          perfil_administrativo: []
        }
        this.dtFiltro = { ...this.filters }
      },
      actionBackOffice (login_usuario, valor_backoffice, $event) {
        $event = false
        const backoffice = !valor_backoffice ? ' desativar ' : ' ativar '
        alert({
          text: 'Tem certeza que deseja' + backoffice + 'o acesso ao backoffice para o usuário ' + login_usuario + '?',
          buttons: {
            'Cancelar': () => { this.filtrar() },
            'Confirmar': () => {
              this.alterarBackOffice(login_usuario, !!valor_backoffice).then((msg) => {
                notification(
                  AlertTypes.SUCCESS,
                  msg
                )
              }).catch(() => notification('error', 'Não foi possível alterar o acesso ao backoffice!'))
            }
          }
        })
      },
      actionPerfilAdmin (login_usuario, valorAdmin) {
        const perfilSelecionado = this.tipos_usuarios.find(p => p.value === valorAdmin)
        const nome_amigavel = perfilSelecionado ? perfilSelecionado.label : 'Perfil desconhecido'
        alert({
          text: 'Tem certeza que deseja mudar as permissões de ' + login_usuario + ' para ' + nome_amigavel + '?',
          buttons: {
            'Cancelar': () => this.filtrar(),
            'Confirmar': () => {
              this.alterarPerfilAdmin(login_usuario, valorAdmin).then((msg) => {
                notification(
                  AlertTypes.SUCCESS,
                  msg
                )
                this.filtrar()
              }).catch(() => alert({
                text: 'Não foi possível alterar as permissões do usuário!',
                buttons: {
                  'OK': () => this.filtrar()
                }
              }))
            }
          }
        })
      },
      actionNivelPermissaoAdmin (login_usuario, valorPermissaoAdmin) {
        const nome_amigavel = this.niveis_permissoes_perfil.find(perfil => perfil.value === valorPermissaoAdmin).label
        alert({
          text: 'Tem certeza que deseja mudar o nível de permissão de ' + login_usuario + ' para ' + nome_amigavel + '?',
          buttons: {
            'Cancelar': () => this.filtrar(),
            'Confirmar': () => {
              this.alterarNivelPermissaoAdmin(login_usuario, valorPermissaoAdmin).then((msg) => {
                notification(
                  AlertTypes.SUCCESS,
                  msg
                )
              }).catch((msg) => {
                notification(
                  AlertTypes.ERROR,
                  msg
                )
              })
            }
          }
        })
      },
      async alterarBackOffice (login_usuario, valor_backoffice) {
        return this.$http.put('/painel/backoffice/users', {
          login_usuario,
          valor_backoffice
        }).then(() => {
          return 'Alterado com Sucesso!'
        }).catch(() => {
          this.filtrar()
          return 'Erro ao salvar permissão de venda backoffice!'
        })
      },
      async alterarPerfilAdmin (login_usuario, valor_perfil_admin) {
        return this.$http.put('/painel/backoffice/perfis-administrativos', {
          login_usuario,
          valor_perfil_admin
        }).then(() => {
          return 'Alterado com Sucesso!'
        }).catch(() => {
          return 'Não foi possível alterar as permissões do usuário'
        })
      },
      async alterarNivelPermissaoAdmin (login_usuario, valor_permissao_admin) {
        return this.$http.put('/painel/backoffice/nivel-permissao-administrativa', {
          login_usuario,
          valor_permissao_admin
        }).then(() => {
          return 'Alterado com Sucesso!'
        }).catch(() => {
          return 'Não foi possível alterar as permissões do usuário'
        })
      },
      filtrar () {
        if (this.$refs.filter.validate()) {
          this.dtFiltro = { ...this.filters }
        }
      }
    }
  }
</script>

<style lang="scss">
.data-table-with-inputs{
    .v-messages, .v-text-field__details{
        display: none;
    }
    .v-input{
        margin-top: 10px !important;
        margin-bottom: 10px;
    }
    .v-input--selection-controls{
        margin-left: 30px;
    }
}
@import url('../../assets/css/tabs.css');

.tooltip-descricao-backoffice {
    position: absolute;
    left: -150px;
    top: 100%;
    max-width: 200px;
    width: 200px;
    opacity: 0;
    margin-top: 10px;
    padding: 12px;
    background-color: #eee;
    color: #666;
    z-index: 2;
}

.tooltip-descricao-perfil {
    position: absolute;
    margin-top: 10px;
    left: 0;
    top: 100%;
    padding: 12px;
    max-width: 200px;
    width: 200px;
    background-color: #eee;
    color: #666;
    opacity: 0;
    z-index: -2;
}
@media (max-width: 1366px) {
    .v-data-table td {
        font-size: 11.5px;
    }
}
</style>
